import {createTheme} from '@mui/material/styles';


export const theme = createTheme({

    palette: {
        primary: {
            main: "#fff",
            light: '#fffff',
        },
        secondary: {
            main: "#252533",
        },
        info: {
            main: "#047C99",
        },
        success: {
            main: "#818181"
        },
        action: {
            main: "#FFFfff90"
        },
        warning: {
            main: '#fa896b'
        }

    },
    typography: {
        fontFamily: ['Inter', 'sans-serif'].join(','),
    },
    components: {
        MuiGrid: {
            styleOverrides: {
                root: {
                    transition: "all .2s ease-in-out"
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                variant: "filled",
                size: "medium"
            }
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    paddingLeft: 10,
                    paddingRight: 10,
                    borderRadius: 6
                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    paddingLeft: 10
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 6
                }
            }
        },
        MuiButtonBase: {
            variants: [
                {
                    props: {variant: 'efecto'},
                    style: {
                        transition: 'all .1s ease-in-out',
                        borderRadius: 10,
                        '&: hover': {
                            marginTop: -6,
                            boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)",

                        }
                    },
                },


            ],

        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 8,
                    backgroundColor: '#ffffff30',
                    backdropFilter: 'blur(10px)',
                }
            }
        },
        MuiButton: {
            defaultProps: {
                variant: "contained",

            },
            styleOverrides: {
                root: {
                    borderRadius: 0,
                    fontWeight: 600,
                    paddingLeft: 30,
                    paddingRight: 30,
                    fontSize: 16,
                    paddingTop: 6,
                    paddingBottom: 6,
                    textTransform: 'none',
                    boxShadow: 'none'

                },

            }
        },
        MuiDrawer: {
            styleOverrides: {

                paper: {
                    backgroundColor: '#285171'
                }
            }
        },


    }


})
